import React from "react";
import {Modal, Button} from "react-bootstrap";
import ModalBase from "./ModalBase";
import Icon, { ilsGenerateSuccess } from "../../ui/Icon";
import classNames from 'classnames';

import "../../../assets/sass/components/modals/alert-modal.scss";

class AlertModal extends ModalBase {
    
    renderBody = () => {
        const { message, icon, subtitle, children } = this.props;

        return (
            <>
                <Icon svg={icon} />
                <Modal.Title>{message}</Modal.Title>
                {subtitle && <span className="subtitle">{subtitle}</span>}
                {children}
            </>
        )
    };
    
    renderHeader = () => {
    };

    renderFooter = () => {
        const { btnText, btnProps, showFooter } = this.props;

        return showFooter ? (
            <Button
                variant="secondary"
                block
                size="md"
                onClick={() => this.props.onHide()}
                {...btnProps}
            >{btnText}</Button>
        ) : null
    };

    modalClassname = () => classNames("alert-modal", this.props.className);

    static defaultProps = {
        icon: ilsGenerateSuccess,
        message: "Evaluation FInished and Saved",
        subtitle: '',
        btnText: "OK",
        btnProps: {},
        className: '',
        showFooter: true
    };
}

export default AlertModal;
